import React from 'react';
import TableCrud from '../../components/TableCrud';

const InstructorFormIndex = () => {
    const columns = [
        {
            label: "Nome",
            name: "name"
        },
        {
            label: "Código externo",
            name: "externalCode"
        },    
        {
            label: "Empresa",
            name: "tenant.name",
        },    
        {
            label: "Ativo",
            name: "isActive"
        }
    ]

    return (
        <TableCrud title={"Instrutor"} table={"instructor"} columns={columns} canDelete={true}/>
    );
}

export default InstructorFormIndex;
